export default class LocalId {
    private static lastId: number = 0;
    
    static next() : string {
        LocalId.lastId++;
        return `localid_${LocalId.lastId}`;
    }
}